export const queryParamKeys = {
  taxClassIds: 'taxClassIds',
};
